import Stack from '@mui/material/Stack';
import React from 'react';
var DetailBottomBar = function (_a) {
    var menu = _a.menu, children = _a.children;
    return (React.createElement(Stack, { direction: "row", justifyContent: "end", alignItems: "center", height: "52px" },
        menu && React.createElement("div", { style: { marginRight: 'auto' } }, menu),
        children));
};
export default DetailBottomBar;
//# sourceMappingURL=DetailBottomBar.js.map